import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { parseMessages } from 'helpers/parse-dll-error'
import { prepareData } from 'helpers/prepare-req-data'
import client from 'api'
import { AxiosResponse } from 'axios'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadAuftragStichdatumEnabledStatus: 'idle',
    loadAuftragStichdatumEnabledError: undefined as any,
    loadBtKreisTypGebaeudeStatus: 'idle',
    loadBtKreisTypGebaeudeError: undefined as any,
    loadBtKreisTypGebaeudeTeilStatus: 'idle',
    loadBtKreisTypGebaeudeTeilError: undefined as any,
    loadBtKreisTypGeschossStatus: 'idle',
    loadBtKreisTypGeschossError: undefined as any,
    loadBtKreisTypGebaeudeObjStatus: 'idle',
    loadBtKreisTypGebaeudeObjError: undefined as any,
    loadBtKreisTypGebaeudeTeilObjStatus: 'idle',
    loadBtKreisTypGebaeudeTeilObjError: undefined as any,
    loadBtKreisTypGeschossObjStatus: 'idle',
    loadBtKreisTypGeschossObjError: undefined as any,
    loadMelderFlstmStatus: 'idle',
    loadMelderFlstmError: undefined as any,
    loadObjVerwantwIdStatus: 'idle',
    loadObjVerwantwIdError: undefined as any,

    globalList: [] as any[],
    auftragStichdatumEnabled: undefined as any,
    btKreisTypGebaeude: undefined as any,
    btKreisTypGebaeudeObj: undefined as any,
    btKreisTypGebaeudeTeil: undefined as any,
    btKreisTypGebaeudeTeilObj: undefined as any,
    btKreisTypGeschoss: undefined as any,
    btKreisTypGeschossObj: undefined as any,
    melderFlstm: undefined as any,
    objVerwantw: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}

const prepParams = (url: string, globalFilters: any) => {
    const params: any = {}

    if (!url.includes('action=')) {
        params['action'] = 'gte'
    }


    return params
}

const getRespData = (res: AxiosResponse, rejectWithValue: Function | null, singleRes = false) => {
    let data: any = undefined
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            if (rejectWithValue) {
                throw rejectWithValue(parseMessages(res.data.messages))
            }
        } else {
            if (res.data.hasOwnProperty('data')) { // if the response conatins a data element then return it
                data = res.data.data
            } else { // if the response does not contain data element, the return response, but remove the status field
                data = _.omit(res.data, 'status')
            }
        }
    } else {  // backend response
        data = res.data
    }

    if (singleRes && data) {
        if (!data || (Array.isArray(data) && data.length === 0)) {
            if (rejectWithValue) {
                throw rejectWithValue('No data found')
            }
        } else {
            return Array.isArray(data) ? data[0] : data
        }
    } else {
        return data
    }
}

export const loadAuftragStichdatumEnabled = createAsyncThunk('globalSlice/loadAuftragStichdatumEnabled', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/IxHausPlusIni_PlusAuftragStichdatum/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragStichdatumEnabledStatus } = getState().globalSlice
        return loadAuftragStichdatumEnabledStatus !== 'pending'
    }
})

export const loadBtKreisTypGebaeude = createAsyncThunk('globalSlice/loadBtKreisTypGebaeude', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/btkreistyp/?action=eql&DefinedType=3`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadBtKreisTypGebaeudeStatus } = getState().globalSlice
        return loadBtKreisTypGebaeudeStatus !== 'pending'
    }
})

export const loadBtKreisTypGebaeudeTeil = createAsyncThunk('globalSlice/loadBtKreisTypGebaeudeTeil', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/btkreistyp/?action=eql&DefinedType=1`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadBtKreisTypGebaeudeTeilStatus } = getState().globalSlice
        return loadBtKreisTypGebaeudeTeilStatus !== 'pending'
    }
})

export const loadBtKreisTypGeschoss = createAsyncThunk('globalSlice/loadBtKreisTypGeschoss', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/btkreistyp/?action=eql&DefinedType=2`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadBtKreisTypGeschossStatus } = getState().globalSlice
        return loadBtKreisTypGeschossStatus !== 'pending'
    }
})

export const loadBtKreisTypGebaeudeObj = createAsyncThunk('globalSlice/loadBtKreisTypGebaeudeObj', async ({ selectedItem, btKreisTypGebaeude }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/btkrtypobjrel/?action=eql&ObjNr=${selectedItem.OBJNR}&BTKREISTYPID=${btKreisTypGebaeude.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadBtKreisTypGebaeudeObjStatus } = getState().globalSlice
        return loadBtKreisTypGebaeudeObjStatus !== 'pending'
    }
})

export const loadBtKreisTypGebaeudeTeilObj = createAsyncThunk('globalSlice/loadBtKreisTypGebaeudeTeilObj', async ({ selectedItem, btKreisTypGebaeudeTeil }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/btkrtypobjrel/?action=eql&ObjNr=${selectedItem.OBJNR}&BTKREISTYPID=${btKreisTypGebaeudeTeil.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadBtKreisTypGebaeudeTeilObjStatus } = getState().globalSlice
        return loadBtKreisTypGebaeudeTeilObjStatus !== 'pending'
    }
})

export const loadBtKreisTypGeschossObj = createAsyncThunk('globalSlice/loadBtKreisTypGeschossObj', async ({ selectedItem, btKreisTypGeschoss }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/btkrtypobjrel/?action=eql&ObjNr=${selectedItem.OBJNR}&BTKREISTYPID=${btKreisTypGeschoss.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadBtKreisTypGeschossObjStatus } = getState().globalSlice
        return loadBtKreisTypGeschossObjStatus !== 'pending'
    }
})

export const loadMelderFlstm = createAsyncThunk('globalSlice/loadMelderFlstm', async ({ selectedItem }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/flstm/?action=gte&AktBelegungPerHdrId=${selectedItem.MELDERPERID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMelderFlstmStatus } = getState().globalSlice
        return loadMelderFlstmStatus !== 'pending'
    }
})

export const loadObjVerwantwId = createAsyncThunk('globalSlice/loadObjVerwantwId', async ({ selectedItem }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/ncremuser/?action=gte&fields=HDR_ID&VERANTW_TEAMID_FILTER=${selectedItem.USERTEAMID}&VERANTW_OBJNR_FILTER=${selectedItem.OBJNR}&VERANTW_CURRENT_IXUSERID=0`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadObjVerwantwIdStatus } = getState().globalSlice
        return loadObjVerwantwIdStatus !== 'pending'
    }
})

const GlobalSlice = createSlice({
    name: 'globalSlice',
    initialState,
    reducers: {
        resetloadAuftragStichdatumEnabled: (state) => {
            state.auftragStichdatumEnabled = undefined
            state.loadAuftragStichdatumEnabledError = undefined
        },
        resetloadAuftragStichdatumEnabledError: (state) => {
            state.loadAuftragStichdatumEnabledError = undefined
        },
        resetloadBtKreisTypGebaeude: (state) => {
            state.btKreisTypGebaeude = undefined
            state.loadBtKreisTypGebaeudeError = undefined
        },
        resetloadBtKreisTypGebaeudeError: (state) => {
            state.loadBtKreisTypGebaeudeError = undefined
        },
        resetloadBtKreisTypGebaeudeTeil: (state) => {
            state.btKreisTypGebaeudeTeil = undefined
            state.loadBtKreisTypGebaeudeTeilError = undefined
        },
        resetloadBtKreisTypGebaeudeTeilError: (state) => {
            state.loadBtKreisTypGebaeudeTeilError = undefined
        },
        resetloadBtKreisTypGeschoss: (state) => {
            state.btKreisTypGeschoss = undefined
            state.loadBtKreisTypGeschossError = undefined
        },
        resetloadBtKreisTypGeschossError: (state) => {
            state.loadBtKreisTypGeschossError = undefined
        },
        resetloadBtKreisTypGebaeudeObj: (state) => {
            state.btKreisTypGebaeudeObj = undefined
            state.loadBtKreisTypGebaeudeObjError = undefined
        },
        resetloadBtKreisTypGebaeudeObjError: (state) => {
            state.loadBtKreisTypGebaeudeObjError = undefined
        },
        resetloadBtKreisTypGebaeudeTeilObj: (state) => {
            state.btKreisTypGebaeudeTeilObj = undefined
            state.loadBtKreisTypGebaeudeTeilObjError = undefined
        },
        resetloadBtKreisTypGebaeudeTeilObjError: (state) => {
            state.loadBtKreisTypGebaeudeTeilObjError = undefined
        },
        resetloadBtKreisTypGeschossObj: (state) => {
            state.btKreisTypGeschossObj = undefined
            state.loadBtKreisTypGeschossObjError = undefined
        },
        resetloadBtKreisTypGeschossObjError: (state) => {
            state.loadBtKreisTypGeschossObjError = undefined
        },
        resetloadMelderFlstm: (state) => {
            state.melderFlstm = undefined
            state.loadMelderFlstmError = undefined
        },
        resetloadMelderFlstmError: (state) => {
            state.loadMelderFlstmError = undefined
        },
        resetloadObjVerwantwId: (state) => {
            state.objVerwantw = undefined
            state.loadObjVerwantwIdError = undefined
        },
        resetloadObjVerwantwIdError: (state) => {
            state.loadObjVerwantwIdError = undefined
        },
        removeFromGlobalListById: (state, action) => {
            state.globalList = state.globalList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromGlobalListByIds: (state, action) => {
            state.globalList = state.globalList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.globalList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadAuftragStichdatumEnabledStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.globalList = []
            state.loadAuftragStichdatumEnabledStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(loadAuftragStichdatumEnabled.pending, (state) => {
            state.loadAuftragStichdatumEnabledStatus = 'pending'
            state.loadAuftragStichdatumEnabledError = undefined
        })
        builder.addCase(loadAuftragStichdatumEnabled.fulfilled, (state, action) => {
            state.loadAuftragStichdatumEnabledStatus = 'idle'

            {
                state.auftragStichdatumEnabled = action.payload

            }
        })
        builder.addCase(loadAuftragStichdatumEnabled.rejected, (state, action) => {
            state.loadAuftragStichdatumEnabledStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragStichdatumEnabledError = action.error.message
            } else {
                state.loadAuftragStichdatumEnabledError = action.payload
            }
        })

        builder.addCase(loadBtKreisTypGebaeude.pending, (state) => {
            state.loadBtKreisTypGebaeudeStatus = 'pending'
            state.loadBtKreisTypGebaeudeError = undefined
        })
        builder.addCase(loadBtKreisTypGebaeude.fulfilled, (state, action) => {
            state.loadBtKreisTypGebaeudeStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.btKreisTypGebaeude = newItem
            }
        })
        builder.addCase(loadBtKreisTypGebaeude.rejected, (state, action) => {
            state.loadBtKreisTypGebaeudeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadBtKreisTypGebaeudeError = action.error.message
            } else {
                state.loadBtKreisTypGebaeudeError = action.payload
            }
        })

        builder.addCase(loadBtKreisTypGebaeudeTeil.pending, (state) => {
            state.loadBtKreisTypGebaeudeTeilStatus = 'pending'
            state.loadBtKreisTypGebaeudeTeilError = undefined
        })
        builder.addCase(loadBtKreisTypGebaeudeTeil.fulfilled, (state, action) => {
            state.loadBtKreisTypGebaeudeTeilStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.btKreisTypGebaeudeTeil = newItem
            }
        })
        builder.addCase(loadBtKreisTypGebaeudeTeil.rejected, (state, action) => {
            state.loadBtKreisTypGebaeudeTeilStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadBtKreisTypGebaeudeTeilError = action.error.message
            } else {
                state.loadBtKreisTypGebaeudeTeilError = action.payload
            }
        })

        builder.addCase(loadBtKreisTypGeschoss.pending, (state) => {
            state.loadBtKreisTypGeschossStatus = 'pending'
            state.loadBtKreisTypGeschossError = undefined
        })
        builder.addCase(loadBtKreisTypGeschoss.fulfilled, (state, action) => {
            state.loadBtKreisTypGeschossStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.btKreisTypGeschoss = newItem
            }
        })
        builder.addCase(loadBtKreisTypGeschoss.rejected, (state, action) => {
            state.loadBtKreisTypGeschossStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadBtKreisTypGeschossError = action.error.message
            } else {
                state.loadBtKreisTypGeschossError = action.payload
            }
        })

        builder.addCase(loadBtKreisTypGebaeudeObj.pending, (state) => {
            state.loadBtKreisTypGebaeudeObjStatus = 'pending'
            state.loadBtKreisTypGebaeudeObjError = undefined
        })
        builder.addCase(loadBtKreisTypGebaeudeObj.fulfilled, (state, action) => {
            state.loadBtKreisTypGebaeudeObjStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.btKreisTypGebaeudeObj = newItem
            }
        })
        builder.addCase(loadBtKreisTypGebaeudeObj.rejected, (state, action) => {
            state.loadBtKreisTypGebaeudeObjStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadBtKreisTypGebaeudeObjError = action.error.message
            } else {
                state.loadBtKreisTypGebaeudeObjError = action.payload
            }
        })

        builder.addCase(loadBtKreisTypGebaeudeTeilObj.pending, (state) => {
            state.loadBtKreisTypGebaeudeTeilObjStatus = 'pending'
            state.loadBtKreisTypGebaeudeTeilObjError = undefined
        })
        builder.addCase(loadBtKreisTypGebaeudeTeilObj.fulfilled, (state, action) => {
            state.loadBtKreisTypGebaeudeTeilObjStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.btKreisTypGebaeudeTeilObj = newItem
            }
        })
        builder.addCase(loadBtKreisTypGebaeudeTeilObj.rejected, (state, action) => {
            state.loadBtKreisTypGebaeudeTeilObjStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadBtKreisTypGebaeudeTeilObjError = action.error.message
            } else {
                state.loadBtKreisTypGebaeudeTeilObjError = action.payload
            }
        })

        builder.addCase(loadBtKreisTypGeschossObj.pending, (state) => {
            state.loadBtKreisTypGeschossObjStatus = 'pending'
            state.loadBtKreisTypGeschossObjError = undefined
        })
        builder.addCase(loadBtKreisTypGeschossObj.fulfilled, (state, action) => {
            state.loadBtKreisTypGeschossObjStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.btKreisTypGeschossObj = newItem
            }
        })
        builder.addCase(loadBtKreisTypGeschossObj.rejected, (state, action) => {
            state.loadBtKreisTypGeschossObjStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadBtKreisTypGeschossObjError = action.error.message
            } else {
                state.loadBtKreisTypGeschossObjError = action.payload
            }
        })

        builder.addCase(loadMelderFlstm.pending, (state) => {
            state.loadMelderFlstmStatus = 'pending'
            state.loadMelderFlstmError = undefined
        })
        builder.addCase(loadMelderFlstm.fulfilled, (state, action) => {
            state.loadMelderFlstmStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.melderFlstm = newItem
            }
        })
        builder.addCase(loadMelderFlstm.rejected, (state, action) => {
            state.loadMelderFlstmStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMelderFlstmError = action.error.message
            } else {
                state.loadMelderFlstmError = action.payload
            }
        })

        builder.addCase(loadObjVerwantwId.pending, (state) => {
            state.loadObjVerwantwIdStatus = 'pending'
            state.loadObjVerwantwIdError = undefined
        })
        builder.addCase(loadObjVerwantwId.fulfilled, (state, action) => {
            state.loadObjVerwantwIdStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.objVerwantw = newItem
            }
        })
        builder.addCase(loadObjVerwantwId.rejected, (state, action) => {
            state.loadObjVerwantwIdStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadObjVerwantwIdError = action.error.message
            } else {
                state.loadObjVerwantwIdError = action.payload
            }
        })

    }
})

export const {
    resetloadAuftragStichdatumEnabled,
    resetloadAuftragStichdatumEnabledError,
    resetloadBtKreisTypGebaeude,
    resetloadBtKreisTypGebaeudeError,
    resetloadBtKreisTypGebaeudeTeil,
    resetloadBtKreisTypGebaeudeTeilError,
    resetloadBtKreisTypGeschoss,
    resetloadBtKreisTypGeschossError,
    resetloadBtKreisTypGebaeudeObj,
    resetloadBtKreisTypGebaeudeObjError,
    resetloadBtKreisTypGebaeudeTeilObj,
    resetloadBtKreisTypGebaeudeTeilObjError,
    resetloadBtKreisTypGeschossObj,
    resetloadBtKreisTypGeschossObjError,
    resetloadMelderFlstm,
    resetloadMelderFlstmError,
    resetloadObjVerwantwId,
    resetloadObjVerwantwIdError,
    removeFromGlobalListById,
    removeFromGlobalListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = GlobalSlice.actions
export default GlobalSlice.reducer
